import React from 'react'
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";
import { HiArrowUpRight } from "react-icons/hi2";

const ProjectsCard = ({ title, des, src, github, live }) => {
  return (
    <div
      style={{
        background: "#13151a",
        border: "1px solid #1e2228",
        borderRadius: "12px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.35s ease",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = "#ff014f33";
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 24px 64px #ff014f0d";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "#1e2228";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Image */}
      <div style={{ position: "relative", overflow: "hidden", height: "200px" }}>
        <img
          src={src}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.5s ease",
            display: "block",
          }}
          onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.06)")}
          onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
        />
        {/* Overlay gradient */}
        <div style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to top, #13151a88, transparent)",
        }} />

        {/* Links on image top-right */}
        <div style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          display: "flex",
          gap: "8px",
        }}>
          <a
            href={github}
            target="_blank"
            rel="noreferrer"
            style={{
              width: "34px", height: "34px",
              borderRadius: "8px",
              background: "rgba(10,11,13,0.85)",
              border: "1px solid #2a2f3a",
              backdropFilter: "blur(8px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#8892a4",
              fontSize: "14px",
              transition: "all 0.2s ease",
              textDecoration: "none",
            }}
            onMouseEnter={e => { e.currentTarget.style.color = "#ff014f"; e.currentTarget.style.borderColor = "#ff014f44"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#8892a4"; e.currentTarget.style.borderColor = "#2a2f3a"; }}
          >
            <BsGithub />
          </a>
          <a
            href={live}
            target="_blank"
            rel="noreferrer"
            style={{
              width: "34px", height: "34px",
              borderRadius: "8px",
              background: "rgba(10,11,13,0.85)",
              border: "1px solid #2a2f3a",
              backdropFilter: "blur(8px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#8892a4",
              fontSize: "14px",
              transition: "all 0.2s ease",
              textDecoration: "none",
            }}
            onMouseEnter={e => { e.currentTarget.style.color = "#ff014f"; e.currentTarget.style.borderColor = "#ff014f44"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#8892a4"; e.currentTarget.style.borderColor = "#2a2f3a"; }}
          >
            <HiArrowUpRight />
          </a>
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: "20px 22px 24px", display: "flex", flexDirection: "column", gap: "10px", flex: 1 }}>
        <h3 style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: "15px",
          fontWeight: 700,
          color: "#f0f2f5",
          letterSpacing: "-0.01em",
        }}>
          {title}
        </h3>
        <p style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "13px",
          lineHeight: 1.7,
          color: "#8892a4",
        }}>
          {des}
        </p>
      </div>
    </div>
  );
}

export default ProjectsCard;